import { mediaGQLFields } from '../media/index.js';
const BASIC_SPACE_SEO_DETAIL_FIELDS = {};
const ALL_SPACE_SEO_DETAIL_FIELDS = {
    image: 'basic',
};
export function spaceSeoDetailGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_SPACE_SEO_DETAIL_FIELDS;
    if (fields === 'all')
        fields = ALL_SPACE_SEO_DETAIL_FIELDS;
    return `
    description
    title
    ${fields.image
        ? `
      image {
        ${mediaGQLFields(fields.image)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=spaceSeoDetail.fields.js.map